<template>
  <v-dialog v-model="dialogVisible" fullscreen hide-overlay :retain-focus="false" persistent
    transition="dialog-bottom-transition">
    <template v-slot:activator="{ on, attrs }">
      <button class="btnDetails" v-bind="attrs" v-on="on" @click="dialogVisible = true"
        style="background-color: transparent;">
        <slot></slot>
      </button>
    </template>
    <v-card>
      <v-toolbar dark color="secondary">
        <v-btn icon dark class="btn btn-primary" @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>{{ $t('companies.label.detailCompany.title') }}</v-toolbar-title>

        <template v-slot:extension>
          <v-tabs v-model="tab" align-with-title>
            <v-tabs-slider color="accent"></v-tabs-slider>

            <v-tab v-for="item in tabsToShow" :key="item">
              {{ item }}
            </v-tab>
          </v-tabs>
        </template>

      </v-toolbar>

      <v-tabs-items v-model="tab" class="container mt-5">

        <v-tab-item>
          <div class="container mt-4">
            <detailsCompanies :company="companyProps" :disablePorcentaje="disableComission" />
          </div>
        </v-tab-item>
        <v-tab-item v-if="userAdminId.userId !== null">
          <upDateUserAdmin :usersAdminIdCompany="userAdminId" :companyId="companyProps.companyId"></upDateUserAdmin>
        </v-tab-item>
        <v-tab-item>
          <companyConfig :company-id="companyProps.companyId" :company-name="companyProps.name"></companyConfig>
        </v-tab-item>
      <!--
        <v-tab-item v-if="productsId.idCategoriaComercial !== null">
          <detailsProducts :productsCompanyId="productsId" :companyId="companyProps.companyId" />
        </v-tab-item>
        -->


      </v-tabs-items>

    </v-card>

  </v-dialog>

</template>

<script>

import detailsCompanies from '@/views/companies/pages/detail_companies/components/form_detail_companies_component.vue';
import upDateUserAdmin from "@/views/users_admin/pages/detail_users_admin/components/form_users_admin_company_component.vue"
import companyConfig from "@/views/company-config/pages/components/company_config_component.vue"
//import detailsProducts from "@/views/companies/pages/detail_companies/components/form_detail_companies_products.vue"

import EventBus from '@/utils/event_bus.js';
import { mapGetters } from "vuex";

import {
  USERSADMIN_M,
  GET_USER_ADMIN_COMPANY_ID,
} from "@/views/users_admin/store/types/types.js";

import {
  COMPANIES_M,
  GET_CATEGORIES_MARKETPLACE_PRODUCTS,
} from "@/views/companies/store/types/types.js";
export default {

  name: "addCompaniesPage",
  components: {
    detailsCompanies,
    upDateUserAdmin,
    companyConfig,
    //detailsProducts
  },
  props: {
    companyProps: {
      required: true
    },

    disableComission: {
      required: true
    },
  },

  data() {
    return {
      dialogVisible: false,
      tab: null
    }
  },

  async mounted() {
    EventBus.$on('reload-update-company', (name) => {
      this.companyProps.nombre = name;
      this.closeDialog()
    });

    EventBus.$on('reload-update-usersAdminId', (name) => {
      this.userAdminId.nombre = name;
      this.closeDialog()
    });

    EventBus.$on('reload-update-productsId', (name) => {
      this.productsId.nombre = name;
      this.closeDialog()
    });

  },

  methods: {

    closeDialog() {
      this.dialogVisible = false;
      window.location.reload();
    },
    logCompanyProps() {
      console.log('companyProps:', this.companyProps);
      console.log('companyProps.nombre:', this.companyProps.nombre);
      console.log('companyProps.companyId:', this.companyProps.companyId);
    },

  },
  computed: {
    ...mapGetters({
      userAdminId: [`${USERSADMIN_M}${GET_USER_ADMIN_COMPANY_ID}`],
      productsId: [`${COMPANIES_M}${GET_CATEGORIES_MARKETPLACE_PRODUCTS}`],

    }),
    itemsToShow() {
      return this.userAdminId.userId !== null ? this.items : this.items.filter(item => item !== "Usuario");
    },
    itemsProducts() {
      return this.productsId.idCategoriaComercial !== null ? this.items : this.items.filter(item => item !== "Productos");
    },

    tabsToShow() {
      const tabs = [this.$t('label.tab')];

      if (this.userAdminId.userId !== null) {
        tabs.push(this.$t('report.label.table.user'));
      }
      tabs.push(this.$t('company-config.tab.label'));
     /* if (this.productsId.idCategoriaComercial !== null) {
        tabs.push("Productos");
      }
      */
      return tabs;
    },
  },
};
</script>

<style lang="css" scoped>
.btnDetails .v-icon {
  color: #6E17A5;
  margin-bottom: 12px;
}
</style>
